import {
  Alert,
  Box,
  Button,
  Grid,
  LinearProgress,
  TextField,
  Typography,
} from "@mui/material";
import { useState } from "react";

import kapuas from "../img/Kapuas.png";
import LogoKapuas from "../img/Logo Kapuas.png";

import { NavLink, useNavigate } from "react-router-dom";
import axios from "axios";
import Api from "../api/RestApi.json";
import { HomeRounded, LoginRounded } from "@mui/icons-material";

function LoginPage(params) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [response, setResponse] = useState(null);
  const [login, setLogin] = useState(true);

  const goTo = useNavigate();

  const loginPost = async (event) => {
    setLogin(false);
    // console.log("Login");
    event.preventDefault();

    //initialize formData
    const formData = new FormData();
    formData.append("username", username);
    formData.append("password", password);

    await axios
      .post(Api.login, formData)
      .then(async (response) => {
        //set token on localStorage
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("name", response.data.user.name);
        // console.log("Token : ", localStorage.getItem('token'))
        //redirect to dashboard

        // formData.append('name', response.data.name);
        // formData.append('token', response.data.token);
        // await axios.post(API,formData);
        // console.log("Token Saved")

        setTimeout(() => {
          goTo("/");
          goTo(0);
        }, 500);
      })
      .catch((error) => {
        //assign error to state "validation"
        console.log(error.response.data);
        setResponse(error.response.data.message);
        setLogin(true);
      });
  };

  return (
    <Box
      component={"main"}
      sx={{ display: "flex" }}
      justifyContent={"center"}
      justifyItems={"center"}
    >
      <Box
        sx={{ position: "fixed" }}
        style={{
          backgroundImage: `url(${kapuas})`,
          backgroundSize: "cover",

          height: "100vh",
          width: "100%",
        }}
      >
        <Box padding={4}>
          <Box
            alignContent={"center"}
            justifySelf={"center"}
            minWidth={"40%"}
            minHeight={"50vh"}
            pb={2}
            px={2}
            boxShadow={5}
            bgcolor={"white"}
            borderRadius={2}
          >
            {!login && <LinearProgress color="warning" />}
            <Box
              component="img"
              sx={{
                maxHeight: { xs: 75, md: 100, lg: 150 },
                maxWidth: { xs: 75, md: 100, lg: 150 },
              }}
              alt="Kabupaten Kapuas."
              src={LogoKapuas}
              margin={2}
            />
            <Typography variant="h5" fontWeight={"bold"}>
              Login
            </Typography>
            <Typography>Silahkan login terlebih dahulu.</Typography>
            {response != null && (
              <Alert severity="error">
                <ul class="mt-0 mb-0">
                  <li>{response}</li>
                </ul>
              </Alert>
            )}
            <form onSubmit={loginPost}>
              <Grid container padding={2} direction={"column"} spacing={2}>
                <Grid>
                  <TextField
                    fullWidth
                    id="username"
                    name="username"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    label="Username"
                  />
                </Grid>

                <Grid>
                  <TextField
                    fullWidth
                    id="password"
                    name="password"
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    label="Password"
                  />
                </Grid>
                <Grid>
                  <Button type="submit" startIcon={<LoginRounded />} variant="contained">
                      <Typography
                        fontWeight={"bold"}
                        fontSize={"large"}
                        color="#FFFFFF"
                      >
                        Login
                      </Typography>
                  </Button>
                </Grid>
                <Grid>
                  <Button
                    variant="text"
                    href="https://bersinar.kapuaskab.go.id/"
                    rel="noopener noreferrer"
                    disableRipple
                    startIcon={<HomeRounded />}
                  >
                    Kembali ke Halaman Utama
                  </Button>
                </Grid>
              </Grid>
            </form>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default LoginPage;
